import { render, staticRenderFns } from "./TypeSelect.vue?vue&type=template&id=395ec3d4&scoped=true&"
import script from "./TypeSelect.vue?vue&type=script&lang=js&"
export * from "./TypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./TypeSelect.vue?vue&type=style&index=0&id=395ec3d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ec3d4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('395ec3d4')) {
      api.createRecord('395ec3d4', component.options)
    } else {
      api.reload('395ec3d4', component.options)
    }
    module.hot.accept("./TypeSelect.vue?vue&type=template&id=395ec3d4&scoped=true&", function () {
      api.rerender('395ec3d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Roster/RosterFormRecord/components/TypeSelect.vue"
export default component.exports